import { render, staticRenderFns } from "./TryNewBack.vue?vue&type=template&id=0211a7fa&lang=pug"
import script from "./TryNewBack.vue?vue&type=script&lang=js"
export * from "./TryNewBack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports